<template>
    <component :is="tag" @click="confirm($event)" v-bind="$props" :class="{ 'cursor-pointer': tag === 'a' }"><slot></slot></component>
</template>

<script>
    import Swal from 'sweetalert2'
    import Button from '../Button'

    export default {
        name: 'Confirm',
        props: {
            title: String,
            text: String,
            color: String,
            icon: String,
            small: Boolean,
            tag: {
                type: [ String, Object ],
                default: () => {
                    return Button
                }
            }
        },
        components: {
            Button
        },
        methods: {
            confirm: function (event) {
                if (this.tag === 'a') event.preventDefault()

                Swal.fire({
                    title: this.title ? this.title : this.$t('confirm.title'),
                    text: this.text,
                    icon: 'warning',
                    showCancelButton: true,
                    buttonsStyling: false,
                    customClass: {
                        confirmButton: 'btn btn-success text-white btn-lg me-2',
                        cancelButton: 'btn btn-light text-dark btn-lg'
                    },
                    confirmButtonText: this.$t('confirm.yes'),
                    cancelButtonText: this.$t('confirm.no')
                }).then((result) => {
                    if (result.value) {
                        this.$emit('confirm')
                    }
                })
            }
        }
    }

</script>
